export default "__VITE_ASSET__bfb0134b__"